// src/pages/StudentReportSingle.jsx
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

/* =====================================================
   MENU
===================================================== */
const MENU = [
  ["/dashboard", "fa-tachometer", "Dashboard"],
  ["/profile", "fa-user", "My Profile"],
  ["/Student-Report", "fa-users", "Students", "active"],
  // ["/School_Report_Dashbord", "fa-building", "Schools"],
];

/* =====================================================
   SAMPLE DATA (replace with API later)
===================================================== */
const STUDENT = {
  id: "STU001",
  name: "Aarav Sharma",
  cls: "10-A",
  roll: 12,
  gender: "Male",
  dob: "14 Aug 2009",
  blood: "O+",
  email: "aarav.sharma@studentdarpan.in",
  phone: "+91 98765 43210",
  address: "42, Mansarovar, Jaipur, Rajasthan",
  father: "Rajesh Sharma",
  mother: "Sunita Sharma",
  guardian: "+91 98765 11111",
  admissionDate: "01 Apr 2020",
  house: "Blue House",
  status: "Active",
  attendance: 96,
  marks: 92,
};

const SUBJECTS = [
  { name: "Mathematics",    marks: 95, total: 100, teacher: "Mrs. Kavita Rao" },
  { name: "Science",        marks: 91, total: 100, teacher: "Mr. Anil Kumar" },
  { name: "English",        marks: 88, total: 100, teacher: "Ms. Priya Nair" },
  { name: "Social Studies", marks: 94, total: 100, teacher: "Mr. Vikas Gupta" },
  { name: "Hindi",          marks: 90, total: 100, teacher: "Mrs. Ritu Sharma" },
  { name: "Computer",       marks: 96, total: 100, teacher: "Mr. Sandeep Verma" },
];

const ATTENDANCE = [
  { month: "Jan", present: 22, total: 24 },
  { month: "Feb", present: 21, total: 22 },
  { month: "Mar", present: 24, total: 25 },
  { month: "Apr", present: 19, total: 20 },
  { month: "May", present: 20, total: 21 },
  { month: "Jun", present: 18, total: 20 },
];

const TIMELINE = [
  { date: "12 Sep 2024", icon: "fa-trophy",      title: "Won Inter-School Quiz",   desc: "Secured 1st position in Science Quiz." },
  { date: "05 Sep 2024", icon: "fa-file-text-o", title: "Term-1 Report Published", desc: "Overall grade: A+ (92%)." },
  { date: "28 Aug 2024", icon: "fa-medal",       title: "Best Attendance Award",   desc: "For August month – 96%." },
  { date: "10 Aug 2024", icon: "fa-pencil",      title: "Unit Test – Mathematics", desc: "Scored 95 / 100." },
];

export default function StudentReportSingle() {
  /* Layout state */
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(
    () => localStorage.getItem("theme") === "dark"
  );
  const { id } = useParams(); // if you want to load by URL id

  /* Persist theme */
  useEffect(() => {
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  const toggleDark = () => setDark((p) => !p);

  const handleLogout = () => {
    if (window.confirm("Pakka logout karna hai?")) {
      localStorage.clear();
      sessionStorage.clear();
      setOpen(false);
      window.location.href = "/";
    }
  };

  const s = STUDENT; // for now, always shows sample
  const initials = s.name.split(" ").map((x) => x[0]).join("").slice(0, 2);

  /* Compute average */
  const totalMarks = SUBJECTS.reduce((a, x) => a + x.marks, 0);
  const totalMax = SUBJECTS.reduce((a, x) => a + x.total, 0);
  const percentage = Math.round((totalMarks / totalMax) * 100);
  const grade =
    percentage >= 90 ? "A+" :
    percentage >= 80 ? "A"  :
    percentage >= 70 ? "B"  :
    percentage >= 60 ? "C"  : "D";

  return (
    <>
      <style>{`
/* =====================================================
   GLOBAL
===================================================== */
:root {
  --bg: #f4f7fb;
  --c: #fff;
  --tx: #163a59;
  --mu: #64748b;
  --bd: #e4ecf5;
  --b: #2563eb;
  --p: #7c3aed;
  --g: #10b981;
  --r: #ef4444;
  --o: #f59e0b;
  --sh: 0 8px 28px rgba(8,35,60,.08);
}
.dk {
  --bg: #0b1220;
  --c: #131c31;
  --tx: #e2e8f0;
  --mu: #94a3b8;
  --bd: #1f2b45;
}
* { box-sizing: border-box; font-family: Inter, "Segoe UI", Arial, sans-serif; }
html, body, #root { width: 100%; min-height: 100%; margin: 0; }
body { overflow-x: hidden; }

/* MAIN WRAPPER */
.pw { width: 100%; min-height: 100vh; background: var(--bg); color: var(--tx); padding-bottom: 40px; }
.lay {
  width: 100%; max-width: 1600px; min-height: 100vh; margin: 0 auto;
  padding: 22px 30px; display: flex; align-items: flex-start; gap: 22px;
}

/* SIDEBAR */
.sb {
  position: sticky; top: 20px;
  width: 250px; min-width: 250px; flex: 0 0 250px;
  background: var(--c); border: 1px solid var(--bd); border-radius: 16px;
  padding: 16px 12px; box-shadow: var(--sh);
  display: flex; flex-direction: column;
}
.br { display: flex; align-items: center; gap: 11px; padding: 6px 8px 16px; margin-bottom: 10px; border-bottom: 1px solid var(--bd); }
.bi {
  width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, rgba(37,99,235,.12), rgba(124,58,237,.10));
  border-radius: 11px; color: var(--b); font-size: 17px;
}
.br small { display: block; color: var(--b); font-size: 9px; font-weight: 800; letter-spacing: 1.4px; }
.br strong { font-size: 16px; font-weight: 800; }
.mn { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 3px; }
.mn a {
  display: flex; align-items: center; gap: 14px; padding: 11px 14px;
  color: var(--tx); font-size: 14px; font-weight: 600; text-decoration: none;
  border-radius: 10px; border: 1px solid transparent; transition: .25s;
}
.mn a i { width: 20px; text-align: center; color: #4b5a6b; }
.mn a:hover { background: #f8fafc; color: var(--b); transform: translateX(3px); }
.mn a.active {
  background: linear-gradient(135deg, rgba(37,99,235,.10), rgba(124,58,237,.08));
  color: var(--b); border-color: rgba(37,99,235,.15);
}
.dv {
  height: 2px; margin: 12px 4px;
  background: linear-gradient(90deg, transparent, var(--r), transparent);
  border-radius: 20px; opacity: .7;
  list-style: none;
}

/* LOGOUT LINK */
.logout-link { color: #ef4444 !important; font-weight: 700 !important; }
.logout-link i { color: #ef4444 !important; }
.logout-link:hover {
  background: rgba(239,68,68,.10) !important;
  color: #dc2626 !important;
  transform: translateX(3px);
}
.logout-link:hover i { color: #dc2626 !important; }

/* MAIN */
.mn2 { flex: 1; min-width: 0; width: 100%; }

/* TOP BAR */
.tb {
  width: 100%; display: flex; align-items: center; gap: 16px;
  margin-bottom: 22px; margin-top: 20px; padding: 18px 24px;
  background: var(--c); border: 1px solid var(--bd); border-radius: 16px; box-shadow: var(--sh);
}
.mb {
  display: none; width: 42px; height: 42px; flex-shrink: 0;
  align-items: center; justify-content: center;
  background: linear-gradient(135deg, var(--b), var(--p));
  border: none; border-radius: 11px; color: #fff; cursor: pointer;
}
.tt { flex: 1; min-width: 0; }
.tt h1 { margin: 0; font-size: 22px; font-weight: 800; }
.tt p { margin: 4px 0 0; color: var(--mu); font-size: 13px; }
.ta { display: flex; align-items: center; gap: 12px; flex-shrink: 0; }
.ib {
  position: relative; width: 42px; height: 42px;
  background: #f8fafc; border: 1px solid var(--bd); border-radius: 11px;
  color: var(--tx); cursor: pointer;
}
.ib:hover { background: #eef2ff; color: var(--b); }
.dt {
  position: absolute; top: 9px; right: 10px;
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--r); border: 2px solid var(--c);
}
.as {
  width: 42px; height: 42px; flex-shrink: 0; border-radius: 50%;
  background: linear-gradient(135deg, var(--b), var(--p));
  color: #fff; display: flex; align-items: center; justify-content: center; font-weight: 800;
}

/* OVERLAY */
.ov { position: fixed; inset: 0; background: rgba(1,11,23,.55); z-index: 998; }

/* BACK BUTTON */
.back {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 8px 14px; margin-bottom: 16px;
  background: var(--c); border: 1px solid var(--bd);
  border-radius: 10px; color: var(--tx);
  font-size: 13px; font-weight: 700; cursor: pointer;
  text-decoration: none; transition: .2s;
}
.back:hover { background: var(--b); color: #fff; border-color: transparent; }

/* PROFILE HERO */
.hero {
  background: var(--c); border: 1px solid var(--bd);
  border-radius: 16px; box-shadow: var(--sh);
  padding: 22px; margin-bottom: 20px;
  display: flex; align-items: center; gap: 20px;
  flex-wrap: wrap;
}
.hero .pf {
  width: 84px; height: 84px; flex: 0 0 84px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--b), var(--p));
  color: #fff; font-size: 28px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 20px rgba(37,99,235,.25);
}
.hero .info { flex: 1; min-width: 200px; }
.hero h2 { margin: 0 0 4px; font-size: 22px; font-weight: 800; }
.hero .sub { color: var(--mu); font-size: 13px; margin-bottom: 10px; }
.hero .chips { display: flex; gap: 8px; flex-wrap: wrap; }
.chip {
  padding: 5px 11px; border-radius: 20px;
  font-size: 11.5px; font-weight: 700;
  background: #f1f5f9; color: var(--tx);
  border: 1px solid var(--bd);
}
.chip.a { background: rgba(16,185,129,.12); color: #059669; border-color: rgba(16,185,129,.25); }
.chip.b { background: rgba(37,99,235,.10); color: var(--b); border-color: rgba(37,99,235,.25); }
.chip.p { background: rgba(124,58,237,.10); color: var(--p); border-color: rgba(124,58,237,.25); }

.hero .acts { display: flex; gap: 8px; flex-wrap: wrap; }
.btn {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 9px 15px; border-radius: 10px;
  font-size: 13px; font-weight: 700; cursor: pointer;
  border: 1px solid var(--bd); background: #fff; color: var(--tx);
  transition: .2s;
}
.btn:hover { background: #eef2ff; color: var(--b); border-color: var(--b); }
.btn.pr {
  background: linear-gradient(135deg, var(--b), var(--p));
  color: #fff; border: none;
}
.btn.pr:hover { opacity: .9; color: #fff; }

/* STATS ROW */
.stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px; margin-bottom: 20px;
}
.stat {
  background: var(--c); border: 1px solid var(--bd);
  border-radius: 14px; padding: 16px 18px;
  box-shadow: var(--sh);
  display: flex; align-items: center; gap: 14px;
  transition: .25s;
}
.stat:hover { transform: translateY(-3px); }
.stat .ic {
  width: 44px; height: 44px; flex: 0 0 44px;
  border-radius: 11px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px;
  background: linear-gradient(135deg, rgba(37,99,235,.10), rgba(124,58,237,.08));
  color: var(--b);
}
.stat .ic.g { background: rgba(16,185,129,.12); color: var(--g); }
.stat .ic.p { background: rgba(124,58,237,.12); color: var(--p); }
.stat .ic.o { background: rgba(245,158,11,.12); color: var(--o); }
.stat h4 { margin: 0; font-size: 20px; font-weight: 800; }
.stat span { font-size: 12px; color: var(--mu); font-weight: 600; }

/* CARD */
.dc {
  background: var(--c); border: 1px solid var(--bd);
  border-radius: 16px; box-shadow: var(--sh);
  padding: 22px; margin-bottom: 20px;
}
.dh {
  display: flex; justify-content: space-between; align-items: center;
  gap: 14px; flex-wrap: wrap; margin-bottom: 18px;
}
.dh h3 { margin: 0; font-size: 16px; font-weight: 800; display: flex; align-items: center; gap: 9px; }
.dh h3 i { color: var(--b); }
.dh p { margin: 4px 0 0; color: var(--mu); font-size: 12.5px; }

/* INFO GRID */
.gd {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.fld {
  min-width: 0;
  display: flex; align-items: flex-start;
  gap: 12px; padding: 14px 16px;
  border: 1px solid var(--bd); border-radius: 12px;
  background: #f8fafc;
  transition: .25s;
}
.fld:hover { transform: translateY(-3px); border-color: var(--b); background: #fff; box-shadow: 0 8px 20px rgba(37,99,235,.10); }
.fi {
  width: 36px; height: 36px; flex: 0 0 36px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 9px;
  background: #eef2ff; color: var(--b);
  font-size: 14px;
}
.fb { flex: 1; min-width: 0; }
.fb label {
  display: block; margin-bottom: 5px;
  color: var(--mu);
  font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: .5px;
}
.fb p {
  margin: 0;
  font-size: 14px; font-weight: 600;
  overflow-wrap: anywhere; word-break: break-word;
}

/* SUBJECTS */
.subj { display: grid; gap: 10px; }
.sj {
  display: grid;
  grid-template-columns: 1.4fr 2fr auto;
  gap: 14px;
  align-items: center;
  padding: 13px 16px;
  border: 1px solid var(--bd); border-radius: 12px;
  background: #f8fafc;
  transition: .25s;
}
.sj:hover { border-color: var(--b); background: #fff; }
.sj .nm { font-size: 13.5px; font-weight: 700; }
.sj .nm small { display: block; color: var(--mu); font-size: 11.5px; font-weight: 500; margin-top: 2px; }
.sj .track {
  height: 8px; background: #eef2f7; border-radius: 20px;
  position: relative; overflow: hidden;
}
.sj .track span {
  position: absolute; left: 0; top: 0; bottom: 0;
  border-radius: 20px;
  background: linear-gradient(90deg, var(--b), var(--p));
}
.sj .mk {
  font-size: 14px; font-weight: 800;
  min-width: 70px; text-align: right;
}
.sj .mk small { color: var(--mu); font-weight: 600; font-size: 11.5px; }

/* ATTENDANCE */
.att {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
}
.atm {
  text-align: center;
  padding: 12px 8px;
  border: 1px solid var(--bd);
  border-radius: 12px;
  background: #f8fafc;
  transition: .25s;
}
.atm:hover { transform: translateY(-3px); box-shadow: 0 8px 20px rgba(37,99,235,.10); }
.atm .bar {
  height: 80px; width: 100%;
  background: #eef2f7; border-radius: 8px;
  position: relative; overflow: hidden;
  margin-bottom: 8px;
}
.atm .bar span {
  position: absolute; left: 0; right: 0; bottom: 0;
  border-radius: 8px;
  background: linear-gradient(180deg, var(--b), var(--p));
  transition: height .4s ease;
}
.atm strong { display: block; font-size: 13px; }
.atm small { color: var(--mu); font-size: 10.5px; }

/* TIMELINE */
.tl { position: relative; padding-left: 26px; }
.tl::before {
  content: ""; position: absolute;
  left: 11px; top: 4px; bottom: 4px;
  width: 2px;
  background: linear-gradient(180deg, var(--b), var(--p));
  opacity: .25;
  border-radius: 20px;
}
.ti { position: relative; padding: 4px 0 16px; }
.ti:last-child { padding-bottom: 0; }
.ti::before {
  content: ""; position: absolute;
  left: -19px; top: 6px;
  width: 12px; height: 12px; border-radius: 50%;
  background: linear-gradient(135deg, var(--b), var(--p));
  box-shadow: 0 0 0 4px rgba(37,99,235,.15);
}
.ti .dt2 { color: var(--mu); font-size: 11.5px; font-weight: 700; margin-bottom: 2px; }
.ti strong { font-size: 13.5px; font-weight: 800; display: block; }
.ti p { margin: 3px 0 0; color: var(--mu); font-size: 12.5px; }

/* =====================================================
   DARK MODE EXTRAS
===================================================== */
.dk .mn a:hover { background: #1a2438; }
.dk .mn a i { color: #94a3b8; }
.dk .mn a.active {
  background: linear-gradient(135deg, rgba(37,99,235,.22), rgba(124,58,237,.18));
  border-color: rgba(37,99,235,.35);
  color: #93c5fd;
}
.dk .ib { background: #1a2438; border-color: var(--bd); color: #cbd5e1; }
.dk .ib:hover { background: #22304a; color: #93c5fd; }
.dk .dt { border-color: var(--c); }
.dk .fld,
.dk .sj,
.dk .atm,
.dk .chip { background: #1a2438; }
.dk .fld:hover,
.dk .sj:hover,
.dk .atm:hover { background: #22304a; border-color: var(--b); }
.dk .fi { background: rgba(37,99,235,.18); color: #93c5fd; }
.dk .back { background: #1a2438; color: #e2e8f0; }
.dk .back:hover { background: var(--b); color: #fff; }
.dk .btn { background: #1a2438; color: #e2e8f0; border-color: var(--bd); }
.dk .btn:hover { background: #22304a; color: #93c5fd; border-color: var(--b); }
.dk .sj .track { background: #0f172a; }
.dk .atm .bar { background: #0f172a; }
.dk .ov { background: rgba(0,0,0,.7); }

/* Dark mode logout */
.dk .logout-link { color: #f87171 !important; }
.dk .logout-link i { color: #f87171 !important; }
.dk .logout-link:hover {
  background: rgba(248,113,113,.15) !important;
  color: #fca5a5 !important;
}
.dk .logout-link:hover i { color: #fca5a5 !important; }

/* Smooth transitions */
.pw, .sb, .tb, .dc, .fld, .sj, .atm, .ib, .back, .btn, .stat {
  transition: background .3s ease, color .3s ease, border-color .3s ease;
}

/* =====================================================
   RESPONSIVE
===================================================== */
@media (max-width: 1199px) {
  .lay { padding: 18px; gap: 18px; }
  .sb { width: 220px; min-width: 220px; flex-basis: 220px; }
  .tb { padding: 16px 18px; }
  .tt h1 { font-size: 20px; }
  .att { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width: 991px) {
  .lay { display: block; width: 100%; padding: 14px; margin-top: 88px; }
  .mn2 { width: 100%; }
  .sb {
    position: fixed; top: 0; left: 0; margin-top: 70px;
    width: 270px; max-width: 85vw; height: 100vh;
    padding: 16px 12px; border-radius: 0;
    transform: translateX(-110%); transition: transform .3s ease;
    z-index: 9999; overflow-y: auto;
  }
  .sb.open { transform: translateX(0); }
  .mb { display: flex; }
  .tb { margin-top: 10px; margin-bottom: 16px; padding: 14px 16px; gap: 12px; }
  .stats { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 768px) {
  .lay { padding: 10px; }
  .tb { padding: 12px; border-radius: 12px; }
  .mb { width: 40px; height: 40px; }
  .tt h1 { font-size: 17px; }
  .tt p { font-size: 11px; }
  .ta { gap: 7px; }
  .ib, .as { width: 38px; height: 38px; }
  .hero { padding: 16px; gap: 14px; }
  .hero .pf { width: 68px; height: 68px; flex-basis: 68px; font-size: 22px; }
  .hero h2 { font-size: 18px; }
  .gd { grid-template-columns: 1fr; gap: 10px; }
  .fld { padding: 12px; }
  .dc { padding: 16px; border-radius: 12px; }
  .sj { grid-template-columns: 1fr; gap: 8px; }
  .sj .mk { text-align: left; }
  .att { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width: 480px) {
  .lay { padding: 8px; }
  .tb { padding: 10px; gap: 9px; margin-top: 6px; }
  .mb { width: 38px; height: 38px; }
  .tt h1 { font-size: 16px; }
  .tt p { display: none; }
  .ta { gap: 5px; }
  .ib, .as { width: 36px; height: 36px; }
  .ib { display: none; }
  .dc { padding: 12px; }
  .stats { grid-template-columns: 1fr 1fr; gap: 8px; }
  .stat { padding: 11px; gap: 8px; }
  .stat .ic { width: 34px; height: 34px; flex-basis: 34px; font-size: 14px; }
  .stat h4 { font-size: 15px; }
  .stat span { font-size: 10px; }
  .att { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .hero .acts { width: 100%; }
  .btn { flex: 1; justify-content: center; }
}
@media (max-width: 360px) {
  .lay { padding: 6px; }
  .tb { padding: 8px; }
  .tt h1 { font-size: 15px; }
  .dc { padding: 10px; }
  .fld { padding: 10px; }
}
      `}</style>

      <div className={`pw ${dark ? "dk" : ""}`}>
        {open && <div className="ov" onClick={() => setOpen(false)} />}

        <div className="lay">
          {/* ---------- SIDEBAR ---------- */}
          <aside className={`sb ${open ? "open" : ""}`}>
            <div className="br">
              <span className="bi">
                <i className="fa fa-graduation-cap" />
              </span>
              <div>
                <small>STUDENT SCHOOL</small>
                <strong>DARPAN</strong>
              </div>
            </div>

            <ul className="mn">
              {MENU.map(([to, ic, nm, cls2]) => (
                <li key={nm}>
                  <Link to={to} className={cls2} onClick={() => setOpen(false)}>
                    <i className={`fa ${ic}`} />
                    {nm}
                  </Link>
                </li>
              ))}

              {/* Red Separator */}
              <li className="dv" />

              {/* Logout */}
              <li>
                <Link
                  to="/"
                  className="logout-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <i className="fa fa-sign-out" />
                  Logout
                </Link>
              </li>
            </ul>
          </aside>

          {/* ---------- MAIN ---------- */}
          <main className="mn2">
            <header className="tb">
              <button className="mb" onClick={() => setOpen(true)} aria-label="Open Menu">
                <i className="fa fa-bars" />
              </button>

              <div className="tt">
                <h1>Student Report</h1>
                <p>{s.name} · {s.id}{id ? ` · ${id}` : ""}</p>
              </div>

              <div className="ta">
                {/* <button className="ib" onClick={toggleDark} title="Toggle theme">
                  <i className={`fa ${dark ? "fa-sun-o" : "fa-moon-o"}`} />
                </button> */}
                <button className="ib">
                  <i className="fa fa-bell" />
                  <span className="dt" />
                </button>
                <div className="as">{s.name[0]}</div>
              </div>
            </header>

            {/* Back */}
            <Link to="/dashboard" className="back">
              <i className="fa fa-arrow-left" /> Back to all students
            </Link>

            {/* ---------- HERO ---------- */}
            <section className="hero">
              <div className="pf">{initials}</div>

              <div className="info">
                <h2>{s.name}</h2>
                <div className="sub">
                  <i className="fa fa-id-badge" /> {s.id} &nbsp;·&nbsp;
                  <i className="fa fa-graduation-cap" /> Class {s.cls} &nbsp;·&nbsp;
                  Roll No. {String(s.roll).padStart(2, "0")}
                </div>
                <div className="chips">
                  <span className={`chip ${s.status === "Active" ? "a" : ""}`}>
                    <i className="fa fa-circle" style={{ fontSize: 7, marginRight: 5 }} />
                    {s.status}
                  </span>
                  <span className="chip b">
                    <i className="fa fa-home" /> {s.house}
                  </span>
                  <span className="chip p">
                    <i className="fa fa-tint" /> {s.blood}
                  </span>
                </div>
              </div>

              <div className="acts">
                <button className="btn"><i className="fa fa-pencil" /> Edit</button>
                <button className="btn"><i className="fa fa-print" /> Print</button>
                <button className="btn pr"><i className="fa fa-download" /> Report Card</button>
              </div>
            </section>

            {/* ---------- STATS ---------- */}
            <div className="stats">
              <div className="stat">
                <div className="ic"><i className="fa fa-percent" /></div>
                <div>
                  <h4>{percentage}%</h4>
                  <span>Overall</span>
                </div>
              </div>
              <div className="stat">
                <div className="ic g"><i className="fa fa-star" /></div>
                <div>
                  <h4>{grade}</h4>
                  <span>Grade</span>
                </div>
              </div>
              <div className="stat">
                <div className="ic p"><i className="fa fa-calendar-check-o" /></div>
                <div>
                  <h4>{s.attendance}%</h4>
                  <span>Attendance</span>
                </div>
              </div>
              <div className="stat">
                <div className="ic o"><i className="fa fa-book" /></div>
                <div>
                  <h4>{SUBJECTS.length}</h4>
                  <span>Subjects</span>
                </div>
              </div>
            </div>

            {/* ---------- PERSONAL INFO ---------- */}
            <section className="dc">
              <div className="dh">
                <div>
                  <h3><i className="fa fa-user" /> Personal Information</h3>
                  <p>Basic details of the student</p>
                </div>
              </div>

              <div className="gd">
                <div className="fld">
                  <div className="fi"><i className="fa fa-user" /></div>
                  <div className="fb"><label>Full Name</label><p>{s.name}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-venus-mars" /></div>
                  <div className="fb"><label>Gender</label><p>{s.gender}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-birthday-cake" /></div>
                  <div className="fb"><label>Date of Birth</label><p>{s.dob}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-tint" /></div>
                  <div className="fb"><label>Blood Group</label><p>{s.blood}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-envelope-o" /></div>
                  <div className="fb"><label>Email</label><p>{s.email}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-phone" /></div>
                  <div className="fb"><label>Phone</label><p>{s.phone}</p></div>
                </div>
                <div className="fld" style={{ gridColumn: "span 2" }}>
                  <div className="fi"><i className="fa fa-map-marker" /></div>
                  <div className="fb"><label>Address</label><p>{s.address}</p></div>
                </div>
              </div>
            </section>

            {/* ---------- FAMILY / SCHOOL ---------- */}
            <section className="dc">
              <div className="dh">
                <div>
                  <h3><i className="fa fa-users" /> Family & School</h3>
                  <p>Guardian and admission details</p>
                </div>
              </div>

              <div className="gd">
                <div className="fld">
                  <div className="fi"><i className="fa fa-male" /></div>
                  <div className="fb"><label>Father</label><p>{s.father}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-female" /></div>
                  <div className="fb"><label>Mother</label><p>{s.mother}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-phone" /></div>
                  <div className="fb"><label>Guardian Contact</label><p>{s.guardian}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-calendar" /></div>
                  <div className="fb"><label>Admission Date</label><p>{s.admissionDate}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-home" /></div>
                  <div className="fb"><label>House</label><p>{s.house}</p></div>
                </div>
                <div className="fld">
                  <div className="fi"><i className="fa fa-graduation-cap" /></div>
                  <div className="fb"><label>Class</label><p>{s.cls}</p></div>
                </div>
              </div>
            </section>

            {/* ---------- SUBJECTS ---------- */}
            <section className="dc">
              <div className="dh">
                <div>
                  <h3><i className="fa fa-book" /> Subject-wise Performance</h3>
                  <p>Marks obtained in each subject</p>
                </div>
              </div>

              <div className="subj">
                {SUBJECTS.map((x) => {
                  const pct = Math.round((x.marks / x.total) * 100);
                  return (
                    <div className="sj" key={x.name}>
                      <div className="nm">
                        {x.name}
                        <small>{x.teacher}</small>
                      </div>
                      <div className="track"><span style={{ width: `${pct}%` }} /></div>
                      <div className="mk">
                        {x.marks}<small> / {x.total}</small>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>

            {/* ---------- ATTENDANCE ---------- */}
            <section className="dc">
              <div className="dh">
                <div>
                  <h3><i className="fa fa-calendar-check-o" /> Monthly Attendance</h3>
                  <p>Present days out of working days</p>
                </div>
              </div>

              <div className="att">
                {ATTENDANCE.map((a) => {
                  const pct = Math.round((a.present / a.total) * 100);
                  return (
                    <div className="atm" key={a.month}>
                      <div className="bar">
                        <span style={{ height: `${pct}%` }} />
                      </div>
                      <strong>{pct}%</strong>
                      <small>{a.month} · {a.present}/{a.total}</small>
                    </div>
                  );
                })}
              </div>
            </section>

            {/* ---------- TIMELINE ---------- */}
            <section className="dc">
              <div className="dh">
                <div>
                  <h3><i className="fa fa-clock-o" /> Recent Activity</h3>
                  <p>Latest events and achievements</p>
                </div>
              </div>

              <div className="tl">
                {TIMELINE.map((t, i) => (
                  <div className="ti" key={i}>
                    <div className="dt2">{t.date}</div>
                    <strong><i className={`fa ${t.icon}`} style={{ color: "var(--b)", marginRight: 8 }} />{t.title}</strong>
                    <p>{t.desc}</p>
                  </div>
                ))}
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}